import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "Will it replace my team?",
      answer: "No. It handles repetitive tasks so your team can focus on closing & service."
    },
    {
      question: "Does it learn our offers?",
      answer: "Yes—upload FAQs, services, pricing rules. The agent only answers from approved content."
    },
    {
      question: "Can it take payments?",
      answer: "Yes—quotes, deposits, invoices via Stripe; all logged in your CRM."
    },
    {
      question: "What about compliance?",
      answer: "DNC, opt-in/opt-out, call recording controls, audit logs, encryption—all built in."
    }
  ];

  return (
    <section className="py-16 space-y-8">
      <div className="text-center space-y-4">
        <h2 className="text-3xl md:text-4xl font-bold text-foreground">
          Frequently Asked Questions
        </h2>
        <p className="text-muted-foreground text-base max-w-2xl mx-auto">
          Common questions about Neil AI
        </p>
      </div>

      <div className="max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
